<!-- Encabezado del Modal (solo si el status es 1) -->
<div class="modal-title d-flex justify-content-end" *ngIf="messageError[0]?.iconX">

  <!-- Botón de cierre -->
  <div class="button-x justify-content-end d-flex">
    <img
      class="cursor-pointer pr-4"
      src="assets/image/modal/close-modal.svg"
      alt="Cerrar"
      width="19px"
      (click)="exit()"
    />
  </div>
</div>
<div class="content-message d-flex align-items-center justify-content-center hp-100" [ngClass]="messageError[0].classCustom?messageError[0].classCustom:'p-16'">
  <div class="ta-c w-100 py-24 ta-c">
    <div class="ta-c img-password" *ngIf="messageError[0]?.icon">
      <img src="{{messageError[0].icon}}" alt="alert">
    </div>
    <div class="ta-c vw-100 container-iconText" *ngIf="messageError[0]?.iconText">
      <span class="img-iconText"> {{messageError[0].iconText}}</span>
     </div>
    <div class="pt-16">
      <div [ngClass]="(messageError[0].classCustom)?(messageError[0].classCustom):'headingMessage line-height-28 mb-8'">{{ messageError[0].title }}</div>
    </div>
    <div class="align-items-center line-height-16">
      <span class="message-alert font-regular " [innerHTML]="messageError[0].description">
        {{ messageError[0].description }}
      </span>
    </div>
    <div *ngIf="messageError[0].button" class="mt-24 d-flex content-button justify-content-center">
      <ng-container *ngIf="messageError[0]?.classCustom!=='exitMassExcel-custom';else exitButton">
      <button mat-flat-button color="accent"class="font-bold-dali ph-24 vw-100" (click)="buttonRetry(messageError[0].textButton)">
        <span *ngIf="!loginInProcess" [innerHTML]="messageError[0].textButton"></span>
        <span *ngIf="loginInProcess">
          <mat-icon>
            <mat-spinner diameter="24"></mat-spinner>
          </mat-icon>
        </span>
      </button></ng-container>
      <ng-template #exitButton>
        <button  class="btn-green d-flex justify-content-center align-items-center" (click)="onClose()" >
          <span *ngIf="!loginInProcess" [innerHTML]="messageError[0].textButton" class="d-flex justify-content-center align-items-center"></span>
          <span *ngIf="loginInProcess" class="d-flex justify-content-center align-items-center">
            <mat-icon>
              <mat-spinner diameter="24"></mat-spinner>
            </mat-icon>
          </span>
        </button>
      </ng-template>
    </div>
  </div>
</div>
